module.exports = __webpack_public_path__ + "img/vila-gale-estoril.2c5d8bc9.jpg";